import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import FormatCurrency from 'components/Common/FormatCurrency'
import Group from 'components/utils/Group'
import type { TravellerBudgetLine } from 'businessTraveller/selectors/itemPolicy/itemPolicyBudgetUtils'
import React from 'react'

interface Props {
  travellerLines: Array<TravellerBudgetLine>
  numberOfNights: number
}

export default function BusinessTravellerItemPolicyHotelBudgetTooltipModal(props: Props) {
  const { travellerLines, numberOfNights } = props

  return (
    <Modal title="Traveller accommodation budgets">
      <Group direction="vertical" gap={12}>
        {travellerLines.map(line => (
          <Group key={line.employeeId} direction="horizontal" horizontalAlign="space-between" gap={16}>
            <BodyText variant="large">{line.displayName}</BodyText>
            <BodyText variant="large">
              {(!line.hasPolicy || line.perNightPerRoom == null) && <div>No item policy applies</div>}
              {(line.hasPolicy && line.perNightPerRoom != null) && (
                <>
                  <FormatCurrency
                    currency={line.currencyCode ?? undefined}
                    value={line.perNightPerRoom * numberOfNights}
                    format="dynamicDollar"
                  />{' '}
                  per room
                </>
              )}
            </BodyText>
          </Group>
        ))}
      </Group>
    </Modal>
  )
}
